import styled from "styled-components";

import { colors } from "shared/ui";

export const SectionTitle = styled.div`
    font-size: 15px;
    font-weight: 700;
    color: ${colors.textPrimary};
`;
